var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
export var PrimaryLink = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :hover {\n    color: ", ";\n  }\n  :visited {\n    ", ";\n  }\n"], ["\n  :hover {\n    color: ", ";\n  }\n  :visited {\n    ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.coral;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.smoke;
});
var templateObject_1;
